import { View, Text, Image } from "@react-pdf/renderer";

import { Colors } from "../../../configs";
import { image3, image4 } from "../customer/imagesStrings";
import { formatUSDate } from "../../../util/common-functions";

const ReportFooter = () => (
  <View
    fixed
    style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
    }}
  >
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginLeft: 48,
        marginBottom: 10,
        marginRight: 30,
        marginTop: 5,
      }}
    >
      <Text
        style={{ fontSize: 6, color: Colors.REPORT_GRAY, marginBottom: 35 }}
      >
        Originally developed by: DryCleanX
      </Text>
      <View style={{ display: "flex", flexDirection: "row", gap: 5 }}>
        <Text style={{ fontSize: 6, color: Colors.REPORT_GRAY }}>
          Printed by: John Roy | {formatUSDate(new Date())}{" "}
          {new Date().toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })}
        </Text>
        <Image src={image3} style={{ width: 35, height: 10 }} />
      </View>
    </View>

    <Image
      src={image4}
      style={{
        width: "100%",
        height: "auto",
        position: "absolute",
        bottom: 0,
      }}
    />
  </View>
);

export default ReportFooter;
